import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Text from 'UIKit/Text'
import { Time } from 'config/constants'
import { timestampOfDay } from 'config/types/bonus'
import { useCountDown } from 'hooks/useCountdown'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { timeLeftUnitV2 } from 'utils'
import { minTwoDigits } from 'utils/numberHelper'
import { displayCountdownTimeUnit } from 'views/Cashback/utils'

interface BoostInUseCountDownProps {
  expiredTime: number
}

const BoostInUseCountDown: React.FC<BoostInUseCountDownProps> = ({ expiredTime }) => {
  const { t } = useTranslation()
  const [timeLeftDisplayTemplate, timeAmount] = timeLeftUnitV2(expiredTime, {
    [Time.DAY]: ['day', 'days'],
  })

  const cashbackExpireTimeRef = useCountDown(
    expiredTime,
    (s, m, h) => `
      ${displayCountdownTimeUnit('', 'Hour', minTwoDigits(h))}
      <div class='colon-mark'>:</div>
      ${displayCountdownTimeUnit('', 'Min', minTwoDigits(m))}
      <div class='colon-mark'>:</div>
      ${displayCountdownTimeUnit('', 'Sec', minTwoDigits(s))}
    `,
    () => {},
  )

  const isOneDayLeft = expiredTime - new Date().getTime() < timestampOfDay

  return (
    <BackgroundCountDown>
      {isOneDayLeft ? (
        <StyledCountdownContent ref={cashbackExpireTimeRef} />
      ) : (
        <Text fontSize="12px" letterSpacing={0.24} bold color="success" textAlign="center" whiteSpace="nowrap">
          {t(`${timeLeftDisplayTemplate} left`, {
            time: timeAmount,
          })}
        </Text>
      )}
    </BackgroundCountDown>
  )
}

const StyledCountdownContent = styled(Flex)`
  color: ${({ theme: { colors } }) => colors.success};

  .day,
  .hour,
  .min,
  .sec {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .value {
      width: 20px;
      height: fit-content;
      display: flex;
      justify-content: center;
      font-size: 12px;
      font-weight: 700;
      font-family: 'Montserrat';

      color: ${({ theme: { colors } }) => colors.success};
    }

    .unit {
      font-size: 12px;
      font-weight: 400;

      color: ${({ theme: { colors } }) => colors.success};
    }
  }

  .colon-mark {
    color: ${({ theme: { colors } }) => colors.success};
    font-size: 12px;
    font-weight: 700;
  }
`

const BackgroundCountDown = styled(Box)`
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
  padding: 8px 12px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.04);
  margin-left: 4px;
`

export default BoostInUseCountDown
